import { REDIRECT_CONFLICT, CLOSE_EULA, COUNTRY_CHANGE, TOGGLE_SIZE_BUTTON, 
         FETCH_WORKLOADS, FETCH_DEFAULT_DATA, FETCH_SOLUTION,
         FETCH_GRBOM, FETCH_GR_INPUT, FETCH_BOM, FETCH_CONFIGDETAILS, 
         ADD_SESSION, UPDATE_SESSION, CHANGE_SESSION, DELETE_SESSION, ERROR_SESSION,
         API_REQUEST, API_REQUEST_POST,SHARE_SELECTION,
         SAVE_WORKLOAD, SAVE_SOLUTION, SAVE_DATA,DOWNLOAD_FILE,API_REQUEST_BLOB,API_REQUEST_POST_BLOB,
         LOAD_USER_DATA, LOAD_SELECTION,VALIDATE_WORKLOAD, FETCH_RA_BOM, FETCH_SOLUTION_ADVANCED,DELETE_SELECTION,OPENED_SAVEWORKLOAD,
         UNSUBSCRIBE_USER_DATA,FETCH_METRICS_DATA,ACCEPT_WLSL,REJECT_WLSL,LOAD_NOTIFICATIONS, FETCH_COMPARE_METRICS_DATA, COMPARE_SOL_DATA,FETCH_COMPARE_SOLUTION, EPA_ACTV_SOLN_CHANGE,EPA_FETCH_SUPPORTEDLIST,EPA_DOWNLOAD_METRICS,EPA_EXPORT_COMPARESOLUTIONDATA,POST_USER_DATA,UPDATE_LOOKUPSERVERS,CLEAR_GUIDANCE_ERROR,POSTSSET_PENDING,FETCH_SETTINGS,GET_WORKLOAD_WITH_MAINSTREAM, COMPARE_GLGROWTH_DATA, SAP_SOL_PREVIEW, SAPHANA_SOL_PREVIEW, SAPTDI_SOL_PREVIEW } from '../constants/actionTypes';
import { serviceUrl,said } from '../../AppConfig';


export const EPAActvSolnChange = ( data ) => ({
  type: EPA_ACTV_SOLN_CHANGE, 
  payload: { data }
});
export const saveworkloadopened = (value) => ({
  type: OPENED_SAVEWORKLOAD,
  payload: {
    data: value,
  }
});
export const redirectPage = ( isTrue, path ) => ({
  type: REDIRECT_CONFLICT, 
  payload: { isTrue, path }
});

export const addSession = (id,name ) => ({
  type: ADD_SESSION, 
  payload: {id,name}
});

export const changeSession = (id) => ({
  type: CHANGE_SESSION, 
  payload: {id}
});

export const toggleSizeButton = (value) => ({
  type: TOGGLE_SIZE_BUTTON,
  payload: {value}  
});

export const updateSession = (session) => ({
  type: UPDATE_SESSION, 
  payload: {session}
});

export const SaveCurrentSession = () => ({
  type: SAVE_DATA,  
});

export const deleteSession = (id) => ({
  type: DELETE_SESSION, 
  payload: {id}
});

export const errorValidataion = (errorMsg) => ({
  type: ERROR_SESSION,
  payload:{errorMsg}
});

export const updateCountry = (country) => ({
  type: COUNTRY_CHANGE,
  payload:{country}
});
export const updateEULA = (data) => ({
  type: CLOSE_EULA,
  payload:{data}
});

export const refArchSession = ( UserData ) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'EPA/LoadReferenceArchitectrureSolution',
    data : UserData,
    next: LOAD_SELECTION 
  }
});

export const sapSolPreview = (UserData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+ said+'/SAPSolutionPreview', 
    data: UserData,   
    next: SAP_SOL_PREVIEW
  }
});

export const sapHanaSolPreview = (UserData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+ said+'/GetSolutionPreview', 
    data: UserData,   
    next: SAPHANA_SOL_PREVIEW
  }
});

export const sapTdiSolPreview = (UserData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+ said+'/GetSolutionPreview', 
    data: UserData,   
    next: SAPTDI_SOL_PREVIEW
  }
});

export const refArchBOM = ( UserData ) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'EPA/LoadReferenceArchitectrureSolution',
    data : UserData,
    next: FETCH_RA_BOM 
  }
});

export const fetchCompareSolution = (UserData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/FetchCompareSolution',
    next: FETCH_COMPARE_SOLUTION,
    data: UserData
  }
});

export const fetchMetricsData = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/GetMetricsData',
    next: FETCH_METRICS_DATA,
    data: sessionID
  }
});

export const fetchCompareMetricsData = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/GetCompareMetricsData',
    next: FETCH_COMPARE_METRICS_DATA,
    data: sessionID
  }
});

export const downloadMetricsData = (data) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/ExportMetricsData',
    next: EPA_DOWNLOAD_METRICS,
    data: data
  }
});   

export const downloadFile = (data) => ({
  type: API_REQUEST_BLOB,
  payload: {
    url: data.url,
    next: DOWNLOAD_FILE,
    fileName:data.name
  }
});

export const downloadSolutionPreview = (data) => ({
  type: API_REQUEST_POST_BLOB,
  payload: {
    url: serviceUrl+'SizingEngine/GenerateSolutionPreviewpdf',
    next: DOWNLOAD_FILE,
    fileName:data.name,
    data: data
  }
})

export const exportCompareSolution=(data)=>({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/ExportCompareSolutionData',
    next: EPA_EXPORT_COMPARESOLUTIONDATA,
    data: data
  }
})

export const exportCompareSolutionData=(data)=>({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'EPAvNext/ExportCompareSolutionData',
    next: EPA_EXPORT_COMPARESOLUTIONDATA,
    data: data
  }
})

export const fetchWorkloads = () => ({
  type: API_REQUEST,
  payload: {
    url: serviceUrl+'Dummy/getSizerDefaults',
    next: FETCH_WORKLOADS 
  }
});

export const fetchBOMString = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/GenerateBillOfMaterial',
    data:sessionID,
    next: FETCH_BOM 
  }
});

export const fetchGRinput=(sessionID)=>({
  type:API_REQUEST_POST,
  payload:{
    url:serviceUrl+'SizingEngine/GenerateGRInput',
    data:sessionID,
    next:FETCH_GR_INPUT  
}
});

export const fetchGRBomInput=(sessionID)=>({
  type:API_REQUEST_POST,
  payload:{
    url:serviceUrl+'SizingEngine/GenerateBOMforGR',
    data:sessionID,
    next:FETCH_GRBOM  
}
});

export const fetchConfigString = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/GenerateConfigurationDetails',
    data:sessionID,
    next: FETCH_CONFIGDETAILS 
  }
});

export const fetchDefaultData = () => ({
  type: API_REQUEST,
  payload: {
    // url: 'http://16.100.138.154/api/ExchangeSizer',
    // url: 'http://128.88.150.172:8090/api/ExchangeSizer', 
    url: serviceUrl+said+'/GetSizerDefaults',
    //url: 'http://16.107.49.148:99/Services/CS750VirtSizer/GetSizerDefaults',
    next: FETCH_DEFAULT_DATA 
  }
});

export const getSolution = (workload) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/SizeSolution',
    data: workload,
    next: FETCH_SOLUTION 
  }
});


export const getAdvancedSolution = (workload) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'API/ExternalSizing/AdvancedSizing',
    data: workload,
    next: FETCH_SOLUTION_ADVANCED 
  }
});


export const validateWorkload = (url, workload) => ({
  type: API_REQUEST_POST,
  payload: {
    url: url,
    data: workload,
    next: VALIDATE_WORKLOAD 
  }
});

export const saveWorkload = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/SaveWorkload',
    data: sessionID,
    next: SAVE_WORKLOAD
  }  
});

export const saveSolution = (sessionID) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/SaveSolution',
    data: sessionID,
    next: SAVE_SOLUTION
  }  
});

export const loadSessionList = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/FetchUserData',
    data: userData,
    next: LOAD_USER_DATA
  }  
});

export const loadSessionfromSSET = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/GetSSETData',
    data: userData,
    next: LOAD_SELECTION
  }  
});

export const loadSessionItem = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/getSelection',
    data: userData,
    next: LOAD_SELECTION
  }  
});

export const deleteSessionItem = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/DeleteSelection',
    data: userData,
    next: DELETE_SELECTION
  }  
});

export const shareItems = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/CreateNotification',
    data: userData,
    next: SHARE_SELECTION
  }  
});

export const loadNotifications = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/FetchNotifications',
    data: userData,
    next: LOAD_NOTIFICATIONS
  }  
});

export const acceptwlsl = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/ShareSelection',
    data: userData,
    next: ACCEPT_WLSL
  }  
});

export const rejectwlsl = (userData) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/RejectNotification',
    data: userData,
    next: REJECT_WLSL
  }  
});



export const fetchSupportedList = () => ({
  type: 'API_REQUEST',
  payload: {
    url: serviceUrl+ said+'/GetAllSupportedComponents',    
    next: EPA_FETCH_SUPPORTEDLIST 
  }
});

export const saveUserData = (UserInfo) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/SaveUserInfo',
    next: POST_USER_DATA,
    data: UserInfo
  }
});

export const deleteUserData = (UserInfo) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/DeleteUserInfo',
    next: UNSUBSCRIBE_USER_DATA,
    data: UserInfo
  }
});


export const fetchLookupServersList = (UserInfo) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/SupportedServers',    
    next: UPDATE_LOOKUPSERVERS,
    data: UserInfo
  }
});
export const comparedata = (compdata) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+said+'/GetComparedata',
    next: COMPARE_SOL_DATA,
    data: compdata
  }
});

export const compareGlgrowthData = (compdata) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'api/'+said+'/GetComparedata'+'?strSessionID='+`${compdata}`,
    next: COMPARE_GLGROWTH_DATA,
    data: compdata
  }
});

export const updateSettings = (settings) => ({
  type: API_REQUEST_POST,
  payload: {
    url: serviceUrl+'SizingEngine/UserPreferences',
    next: FETCH_SETTINGS,
    data: settings
  }
});

export const fetchSettings = (queryString) => ({
  type: API_REQUEST,
  payload: {    
    url: serviceUrl+'SizingEngine/UserPreferences/'+queryString,    
    next: FETCH_SETTINGS 
  }
});
export const GetWorkloadWithMainstream  = (UserData) => ({
  type: 'API_REQUEST_POST',
  payload: {
    url: serviceUrl+ said+'/GetWorkloadWithMainstream',
    data: UserData,
    next: GET_WORKLOAD_WITH_MAINSTREAM ,
  }
});

export const clearGuidance = () =>({
  type: CLEAR_GUIDANCE_ERROR
})

export const showLoading = (msg) =>({  
  type: POSTSSET_PENDING,
  payload:msg
})



// WEBPACK FOOTER //
// ./src/State/actions/sessions.js